import { assert } from '@sama/js-core';
import { matches } from '@sama/micro-dash';
import { isEmpty, isUndefined } from 'lodash';
import { MultipleChoiceAttribute } from '../../../team-apis/otterdam/taxonomy';
import { AttributeHelper } from './attribute-helper';

export class MultipleChoiceAttributeHelper extends AttributeHelper<MultipleChoiceAttribute> {
  getLabel(values: string[], attribute: MultipleChoiceAttribute) {
    if (isUndefined(values)) {
      return '';
    }
    return values
      .map((value) => {
        const attributeOption = this.getMatchingOption(value, attribute);
        assert(
          attributeOption,
          `Attribute option not found for value ${value}`,
        );
        return attributeOption.label;
      })
      .join(', ');
  }

  getDefaultOptionValue(attribute: MultipleChoiceAttribute) {
    return attribute.options
      .filter((option) => option.isDefault)
      .map((option) => option.value);
  }

  isInvalidValue(value: string[], attribute: MultipleChoiceAttribute) {
    if (isEmpty(value)) {
      return true;
    }
    return value.some((val) =>
      isUndefined(this.getMatchingOption(val, attribute)),
    );
  }

  private getMatchingOption(
    answer: string,
    attribute: MultipleChoiceAttribute,
  ) {
    return attribute.options.find(matches({ value: answer }));
  }
}
